<script lang="ts">
  import { cva, type VariantProps } from 'class-variance-authority';
  import type { IconOptions } from './ui/icon/icon.svelte';
  import { cn } from '$lib/utils';
  import Icon from './ui/icon/icon.svelte';

  let className: string | undefined = undefined;
  export { className as class };
  export let icon: IconOptions = 'alert-hexagon';
  export let message: string;
  export let size: VariantProps<typeof host>['size'] | undefined = 'md';

  const host = cva(
    ['bg-accent/10 text-sm/none rounded-xs text-accent flex justify-center items-center gap-1'],
    {
      variants: { size: { sm: 'py-2 px-2.5', md: 'py-2.5 px-3' } }
    }
  );
</script>

<div class={cn(host({ size }), className)}>
  <Icon {icon} size="md" />
  <span>{message}</span>
</div>
